import React from 'react';
import styles from '../../App.module.css';
import FooterLinks from '../../components/layout/FooterLinks'; // ✅ NEW!
import BurgerHint from '../../components/layout/BurgerHint';   // ✅ Burger Tip!

const FaqPage = ({ theme }) => {
  return (
    <div className={`${styles.container} ${theme === 'dark' ? styles.darkBackground : styles.lightBackground}`}>
      <div className={styles.staticContentBox}>
        <h1 className={styles.pageHeading}>❓ Frequently Asked Questions</h1>

        {/* 🍔 Burger Menu Tip */}
        <BurgerHint />

        {/* Table of Contents */}
        <ul>
          <li><a href="#important-tip" className="hover:underline">Important Tip</a></li>
          <li><a href="#adding-relationships" className="hover:underline">How to Add Relationships</a></li>
          <li><a href="#phrasing-tips" className="hover:underline">Phrasing Tips</a></li>
          <li><a href="#giving-feedback" className="hover:underline">Giving Feedback</a></li>
        </ul>

        <hr style={{ margin: '1em 0' }} />

        {/* Important Tip */}
        <h2 id="important-tip" className={styles.sectionHeading}>✨ Important Tip</h2>
        <p>
          To get the best experience with Daisy, it's helpful to introduce important parts of your life early on!
        </p>
        <p style={{ marginTop: '0.5em' }}>
          🧡 You can tell her things like:
        </p>
        <ul>
          <li>"My daughter's name is Samantha."</li>
          <li>"My son's name is Ryan."</li>
          <li>"My best friend's name is Jud."</li>
          <li>"My favorite hobby is painting."</li>
        </ul>
        <p style={{ marginTop: '1em' }}>
          🧠 When Daisy knows these facts about you, her responses will feel more personal, meaningful, and supportive from the start.
        </p>

        {/* Section 1 */}
        <h2 id="adding-relationships" className={styles.sectionHeading}>🧠 How to Add Relationships</h2>
        <p>When telling dAIsy about important people in your life, phrase it clearly and directly:</p>
        <ul>
          <li>✅ <strong>Good:</strong> "My daughter's name is Samantha."</li>
          <li>✅ <strong>Good:</strong> "My daughter's name is Miranda."</li>
          <li>❌ <strong>Bad:</strong> "My daughters are outside and playing."</li>
        </ul>
        <p><em>Tip:</em> Keep relationship introductions simple and avoid mixing in other unrelated actions.</p>

        {/* Section 2 */}
        <h2 id="phrasing-tips" className={styles.sectionHeading}>📝 Phrasing Tips</h2>
        <p>Short, clear sentences help Daisy understand and remember better. Focus on one idea at a time.</p>
        <ul>
          <li>✅ "My best friend is named Jon."</li>
          <li>❌ "My best friend and I are thinking about buying a boat and my cousin is visiting." (Too many ideas!)</li>
        </ul>

        {/* Section 3 */}
        <h2 id="giving-feedback" className={styles.sectionHeading}>📬 Giving Feedback</h2>
        <p>If Daisy ever misunderstands or responds oddly, we’d love your feedback!</p>
        <p>Please use the <strong>Feedback</strong> button in chat to send us quick notes. Your help makes Daisy better every day! 🌼</p>

        {/* Footer */}
        <FooterLinks /> {/* ✅ Footer dropped cleanly here */}
      </div>
    </div>
  );
};

export default FaqPage;
